import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment.prod';
import { ApiList, ApiOne, FaqItem, FaqPageItem, Lang } from 'src/app/models/faq';

@Injectable({
  providedIn: 'root'
})
export class FaqService {

   private api = environment.apiUrl; // ends with /api/

  constructor(private http: HttpClient) {}

  // GET /api/admin/faqs/pages?lang=geo
  getFaqPages(lang: Lang) {
    return this.http.get<ApiList<FaqPageItem>>(
      `${this.api}admin/faqs/pages`,
      { params: { lang } }
    );
  }

  // GET /api/admin/faqs?lang=geo&menu_page=580&search=&visible=all
  getFaqs(lang: Lang, menu_page: number, search = '', visible: 'all' | '1' | '0' = 'all') {
    return this.http.get<ApiList<FaqItem>>(
      `${this.api}admin/faqs`,
      { params: { lang, menu_page: String(menu_page), search, visible } }
    );
  }

  show(id: number, lang: string) {
    return this.http.get<ApiOne<FaqItem>>(
      `${this.api}admin/faqs/${id}`,
      { params: { lang } }
    );
  }

  create(payload: Partial<FaqItem>, lang: string) {
    return this.http.post<ApiOne<FaqItem>>(
      `${this.api}admin/faqs`,
      payload,
      { params: { lang } }
    );
  }

  update(id: number, payload: Partial<FaqItem>, lang: string) {
    return this.http.post<ApiOne<FaqItem>>(
      `${this.api}admin/faqs/${id}`,
      payload,
      { params: { lang } }
    );
  }

  toggleVisible(id: number, lang: Lang) {
    return this.http.post<{ status: string; visible: number }>(
      `${this.api}admin/faqs/${id}/toggle-visible`,
      {},
      { params: { lang } }
    );
  }

  sort(lang: Lang, menu_page: number, ids: number[]) {
    return this.http.post<{ status: string }>(
      `${this.api}admin/faqs/sort`,
      { menu_page, ids },
      { params: { lang } }
    );
  }

  delete(id: number, lang: Lang, soft = true) {
    return this.http.post<{ status: string; message: string }>(
      `${this.api}admin/faqs/${id}/delete`,
      { soft },
      { params: { lang } }
    );
  }
}
